import { prod } from "application/constants/app-constants";

export default function getMarket() {
  let market = "3862";
  if (prod) {
    const urlParams = new URLSearchParams(window.location.search);
    market = urlParams.get("storeid");
  }
  return market;
}
